module.exports = __webpack_public_path__ + "static/img/lc1-1.8a2ca2e.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/lc1-1.png
// module id = 830
// module chunks = 0